import React, { useReducer } from 'react'
import { createContext, ReactNode } from "react";
import { commonInitial, CommonReducer } from '../Store/CommonReducer/CommonReducer';
import { setCommonData } from '../Store/CommonReducer/CommonActions';

interface MyComponentProps {
    children?: ReactNode; // Ensure you define children prop type
}

const CommonContext = createContext<any>(null)
export const CommonContextProvider: React.FC<MyComponentProps> = ({ children }) => {
    const [state, dispatch] = useReducer(CommonReducer, commonInitial)    
    const updateCommonContext = async (data:any) => {
        dispatch(setCommonData(data))
    }
    return (
        <CommonContext.Provider value={{ commonState: state, updateCommonContext }}>{children}</CommonContext.Provider>
    )
}

export default CommonContext